import React, { useMemo, useState } from 'react'
import { useModal } from 'src/utils/overlay'
import styled from 'styled-components'
import { BottomDrawer } from '../modal/BottomDrawer'
import {
	AllowanceChip,
	AllowanceList,
	AllowanceListTypeWithString,
	licenseAllowanceChipList,
	workAllowanceChipList,
} from './AllowanceChip'
import {
	AllowanceListType,
	HandoutAllowanceChip,
	handoutAllowanceChipList,
	HandoutAllowanceListTypeWithString,
} from './Handout/HandoutAllowanceChip'

export interface AllowanceChipListProps {
	productType: string
	studioVersion?: string
	isParsedByMl?: boolean
}

export const AllowanceChipList: React.FC<AllowanceChipListProps> = ({
	productType,
	studioVersion,
	isParsedByMl,
}) => {
	const isStudio = useMemo(() => studioVersion === 'v2', [studioVersion])
	const isEditStudio = useMemo(() => isStudio && isParsedByMl, [studioVersion, isParsedByMl])
	const isWriteStudio = useMemo(() => isStudio && !isParsedByMl, [studioVersion, isParsedByMl])
	const [isDrawerOpen, { open: openDrawer, close: closeDrawer }] = useModal('drawer-modal')
	const [drawerData, setDrawerData] = useState<AllowanceList>({
		key: AllowanceListType.selling,
		color: 'info',
		hasInfo: true,
		link: '/',
		description:
			'라이선스를 구매하게 되면 해당 권리를 계약(1년간)하게 되는 것으로 1회 구매당 총 100개의 저작자료를 쏠북에서 판매할 수 있습니다.',
	})

	if (productType === 'handout')
		//FIXME handout만 임시로 변경된 컴포넌트 추후 모두 hanout 과 동일한 컴포넌트 사용예정
		return (
			<>
				<Container>
					{handoutAllowanceChipList.map((item, idx) => {
						if (item.key === AllowanceListType.editStudio && !isEditStudio) return null
						if (item.key === AllowanceListType.writeStudio && !isWriteStudio)
							return null
						return (
							<HandoutAllowanceChip
								handleDrawer={() => {
									setDrawerData(item)
									openDrawer()
								}}
								key={'allowance-chip' + idx}
								chipItem={item}
								productType={productType}
							/>
						)
					})}
				</Container>
				<BottomDrawer
					title={HandoutAllowanceListTypeWithString[drawerData.key]}
					onClose={closeDrawer}
					open={isDrawerOpen}
					text={drawerData.description}
					link={drawerData.link}
					linkTitle={drawerData.linkTitle}
					position={null}
					name={'drawer-modal'}
				/>
			</>
		)
	if (productType === 'textbook' || 'workbook')
		return (
			<>
				{licenseAllowanceChipList.map((item, idx) => (
					<AllowanceChip
						handleDrawer={() => {
							setDrawerData(item)
							openDrawer()
						}}
						key={'allowance-chip' + idx}
						chipItem={item}
						productType={productType}
					/>
				))}
				<BottomDrawer
					title={AllowanceListTypeWithString[drawerData.key]}
					onClose={closeDrawer}
					open={isDrawerOpen}
					text={drawerData.description}
					link={drawerData.link}
					linkTitle={drawerData.linkTitle}
					position={null}
					name={'drawer-modal'}
				/>
			</>
		)
	return null
}
const Container = styled.div`
	width: 100%;
	display: flex;
	gap: 8px;

	@media (max-width: 1120px) {
		max-width: 388px;
	}
	@media (max-width: 1080px) {
		max-width: 100%;
	}
	@media (max-width: 768px) {
		overflow-x: auto;
	}
`
